import { getAuthenticatedHeaders, logout } from './auth';

const BASE_URL = (process.env.REACT_APP_AUTH_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || 'https://apidev.chemrobotics.com').replace(/\/$/, '');

async function request(path, options = {}) {
  const response = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers: { ...getAuthenticatedHeaders(), ...options.headers },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.status === false) {
    if (response.status === 401 || response.status === 403) logout();
    throw new Error(payload.message || payload.errors?.[0] || 'Unable to load chatbot data.');
  }
  return payload.data || {};
}

export async function getCategories() {
  const data = await request('/chatbot/categories');
  return data.categories || [];
}

export async function getQuestions(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.set(key, value);
  });
  const data = await request(`/chatbot/questions${params.size ? `?${params}` : ''}`);
  return data.questions || [];
}

export function getQuestion(questionId) {
  return request(`/chatbot/question/${encodeURIComponent(questionId)}`);
}

export function executeQuestion(questionId, parameters = {}) {
  return request('/chatbot/question/execute', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ questionId, parameters }),
  });
}

export function askChatbot(question, parameters = {}) {
  return request('/chatbot/ask', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ question, parameters }),
  });
}

const SUGGEST_ENDPOINTS = {
  BASIC_PRODUCT: '/basic-product-info/advance-auto-suggestions',
  CHEMICAL_DIRECTORY: '/chemical-directory/auto-suggestions',
  TECHNICAL_ROUTES: '/technical-routes/auto-suggestions',
};

async function fetchSuggestionsFromEndpoint(endpoint, column, keyword) {
  try {
    const data = await request(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ column, keyword: keyword.trim() }),
    });
    return data?.suggestions || [];
  } catch {
    return [];
  }
}

export async function getAutoSuggestions(platform, column, keyword) {
  if (!platform || !column || !keyword?.trim() || keyword.trim().length < 2) return [];
  const endpoint = SUGGEST_ENDPOINTS[platform];
  return endpoint ? fetchSuggestionsFromEndpoint(endpoint, column, keyword) : [];
}
